/* 🤖 this file was generated by svg-to-ts */
export const matIconKey: {
  name: 'key';
  data: string;
} = {
  name: 'key',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 10h-8.35A5.99 5.99 0 0 0 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6a5.99 5.99 0 0 0 5.65-4H13l2 2 2-2 2 2 4-4.04L21 10zM7 15c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"/></svg>`
};
